<template>
	<div>
		<v-text-field
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			:name="param.name"
			clearable
			@input="$emit('update:value', $event)"
			:readonly="readonly">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-text-field>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false
		}
	},
	methods: {
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		multiIntegerCheck (value) {
			if (!value) return true
			if (value) {
				value.split(',').map(number => {
					let int = parseInt(number, 10)
					if (!Number.isInteger(int)) return 'Nombres entiers uniquement'
				})
			}
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		this.rules.push(this.multiIntegerCheck)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/multi_integer.vue